import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack } from '@mui/material';
import { useRetention } from '../RetentionContext';
import StageTabs from '../components/StageTabs';
import ProfileStage from '../stages/ProfileStage';
import TutorMappingStage from '../stages/TutorMappingStage';
import { getDemo, getRetentionProfile } from '../../../redux/features/retentionSlice';
import PhaseHeader from '../components/PhaseHeader';
import FromCrmCard from '../components/FromCrmCard';

// Phase 1 — stages 1–4 (§2.3). Stages 1–3 are ProfileStage forms (fields in constants/stageFields.js); stage 4 is
// TutorMappingStage (enrol → session preference → TutorMatchPanel → demo attempt).
export default function Onboarding() {
  const { courseEnrollmentId, student, currentStage, progressByStage } = useRetention();
  const dispatch = useDispatch();

  // stages 1–3 read GET /retention/:id/profile, stage 4 GET /retention/:id/demo
  useEffect(() => {
    dispatch(getRetentionProfile(courseEnrollmentId));
    dispatch(getDemo(courseEnrollmentId));
  }, [dispatch, courseEnrollmentId]);

  return (
    <Stack gap={2.5}>
      <PhaseHeader phase={1} currentStage={currentStage} />
      <StageTabs
        phase={1}
        currentStage={currentStage}
        progressByStage={progressByStage}
        renderStage={(no) => (no <= 3 ? <ProfileStage stageNo={no} /> : <TutorMappingStage />)}
        aside={<FromCrmCard student={student} />}
      />
    </Stack>
  );
}
